import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';

export const TrustBar = () => {
  const { language } = useLanguage();
  const t = content[language];
  const items = [...t.trust.items, ...t.trust.items, ...t.trust.items, ...t.trust.items];

  return (
    <section className="py-10 border-y bg-elev/40 relative overflow-hidden" style={{ borderColor: 'var(--border)' }}>
      <div className="container">
        <p className="eyebrow text-center mb-6">{t.trust.title}</p>
        <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
          <div className="marquee-track items-center text-muted text-sm font-medium">
            {items.map((label, i) => (
              <span key={i} className="flex items-center gap-3 text-app">
                <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--brand)' }} />
                <span className="whitespace-nowrap">{label}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
